import { State, createFeatureSelector, createSelector } from "@ngrx/store";
import * as TournamentSummariesReducer from './tournament-summaries.reducer';
import * as mainReducers from '@app/store/features/main/main.reducers';

export const selectMainState = createFeatureSelector<mainReducers.MainState>('main');
export const selectTournamentSummariesState = createSelector(selectMainState, (state) => state.tournamentSummaries);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal,
} = TournamentSummariesReducer.adapter.getSelectors(selectTournamentSummariesState);

export const selectLoader = createSelector(
    selectTournamentSummariesState,
    (state) => state?.loader
);

export const selectEntityById = (id: number) => createSelector(
    selectEntities,
    (entities) => entities[id]
);